import { show } from "@ebay/nice-modal-react";
import { CreateEmbedModal } from "@/interface/ui/modals";
import { canv } from "@/canv/global.js";
import { getTarget } from "@/canv/utils.js";
import { pasteEmbed } from "@/canvasController/helpers";
import tippy from "tippy.js";

export class moreWindow {

    constructor() {
    }

    async open() {
        const moreWindowWrapper = document.createElement('div');
        document.body.append(moreWindowWrapper);

        moreWindowWrapper.outerHTML = this.getWindow();

        const toolsContainer = document.querySelector(".moreWindowContent");

        const options = this.getOptions();
        for (let i = 0; i < options.length; i++) {
            toolsContainer.innerHTML += this.applyItemTemplate(options[i]);
        }

        const moreWindow = document.querySelector(".moreWindow");
        const toolBoxWrapper = document.querySelector(".toolBoxWrapper");
        const toolBoxWrapperSize = toolBoxWrapper.getBoundingClientRect();
        const moreWindowSize = moreWindow.getBoundingClientRect();
        moreWindow.style.top = (toolBoxWrapperSize.top + (toolBoxWrapperSize.height - moreWindowSize.height)).toString() + "px";

        this.init();
    }

    close() {
        const moreWindow = document.querySelector('.moreWindow');
        if (!moreWindow) {
            return;
        }
        document.querySelectorAll(".moreWindowContentItemInfo").forEach(el => {
            if (el._tippy) {
                el._tippy.destroy();
            }
        });

        moreWindow.outerHTML = "";
    }

    init() {
        const items = document.querySelectorAll(".moreWindowContentItem");
        items.forEach(item => {
            item.addEventListener('mouseup', this.itemClick, false);
        });

        tippy(".moreWindowContentItemInfo", {
            content: canv.appInterface.createTooltipContent("JPEG, PNG, PDF до 30 Мб"),
            placement: "right-start",
        });
    }

    getToolsNames() {
        const height = window.innerHeight;
        const defaultToolsNames = ["mediaTool", "embedTool", "tableTool", "cardTool", "emoteTool", "stickersTool"];

        if (height <= 744) {
            defaultToolsNames.unshift("mindMapTool", "commentTool");
        } else if (height <= 768) {
            defaultToolsNames.unshift("commentTool");
        }

        return defaultToolsNames;
    }

    getOptions() {
        const toolsNames = this.getToolsNames();
        const options = [];

        for (const toolName of toolsNames) {
            const tool = canv.toolBox.TryGetToolByName(toolName);
            options.push({
                codeName: tool.getToolName(),
                name: tool.getToolTipName(),
                view: tool.getToolView()
            });
        }

        return options;
    }

    // processors
    itemClick = (e) => {
        const item = getTarget(e, "moreWindowContentItem");
        const codeName = item.getAttribute("codeName");

        if (codeName === "stickersTool") {
            canv.toolBox.TryGetToolByName("stickersTool").select();
        } else if (codeName === 'embedTool') {
            show(CreateEmbedModal).then((embedUrl) => {
                if (!embedUrl) {
                    return;
                }
                pasteEmbed(embedUrl);
            })
        } else {
            canv.toolBox.switchToByName(codeName);
        }

        this.close();

    }

    getWindow() {
        return `
            <div class="moreWindow">
                <div class="moreWindowContent"></div>
            </div>
        `;
    }

    applyItemTemplate(data) {
        let extra = "";

        if (data.codeName === "mediaTool") {
            extra = `<div class="moreWindowContentItemInfo">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_319_3785)">
                                <path d="M8 10.8V8M8 5.2H8.007M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#7C7C91" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_319_3785">
                                    <rect width="16" height="16" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>`;
        }

        return `
        <div class="moreWindowContentItem moreWindowContentItem_${data.codeName}" codeName="${data.codeName}">
            <div class="moreWindowContentItemIcon">${data.view}</div>
            <div class="moreWindowContentItemTitle">${data.name}</div>
            ${extra}
        </div>
    `;
    }
}
